import React, { useEffect, useState } from 'react';
import { Button as ANTButton, Form, notification, Switch } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { Button } from '../../../components/Atom/Button';
import Select from 'components/Atom/Select';
import Input from 'components/Atom/Input';
import http from '../../../utils/http';
import { Banks, PAYMENT_METHOD_TYPES, Wallets, Bnpl, CHECKOUT_COM_AUTH_TYPE } from 'utils/constant';
import { CardAcquirerBanksName, WalletsName, BnplName, RaastBanksName, AuthName, GooglePayBanksName } from 'utils/services';

const mddFieldsGridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr auto',
  gap: 12,
  alignItems: 'end',
};

const GatewayInstance = ({ handleOpen, updateState, store, instanceData, editData = null }) => {
  const [loading, setLoading] = useState(false);
  const gatewayData = editData?.gateway || {};
  const instance_id = editData?._id;
  const isEditMode = !!instance_id;
  const initialPaymentMethod = editData?.payment_method || PAYMENT_METHOD_TYPES.CARD;
  const getInitialGatewayType = () => {
    if (editData?.payment_method) {
      return { type: editData?.payment_method, value: gatewayData?.type };
    }
    return { type: 'card', value: Banks?.BAFL };
  };

  const initialGatewayType = getInitialGatewayType();

  const [bankType, setBankType] = useState(initialGatewayType?.type === PAYMENT_METHOD_TYPES.CARD ? initialGatewayType.value : Banks.BAFL);
  const [authType, setAuthType] = useState(gatewayData?.authType || CHECKOUT_COM_AUTH_TYPE.API);
  const [walletType, setWalletType] = useState(gatewayData?.type || Wallets.JAZZ_CASH);
  const [bnplType, setBnplType] = useState(initialGatewayType?.type === PAYMENT_METHOD_TYPES.BNPL ? initialGatewayType.value : Bnpl.BAADMAY);
  const [raastType, setRaastType] = useState(initialGatewayType?.type === PAYMENT_METHOD_TYPES.RAAST ? initialGatewayType?.value : Banks.BAFL);
  const [googlePayType, setGooglePayType] = useState(initialGatewayType?.type === PAYMENT_METHOD_TYPES.GOOGLE_PAY ? initialGatewayType.value : Banks.BAFL);
  const [PaymentMethodTypeValue, setPaymentMethodType] = useState(initialPaymentMethod);
  const [backupInstances, setBackupInstances] = useState([]);

  const raastMethod = store?.paymentMethods?.find((method) => method?.name === 'raast');
  const isDQRInStore = raastMethod?.raast_payment_methods?.includes('dqr') ?? true;
  const isRTPInStore = raastMethod?.raast_payment_methods?.includes('rtp') ?? false;

  const [form] = Form.useForm();
  useEffect(() => {
    const backupInstancesIds = [];
    if (instanceData && Array.isArray(instanceData)) {
      for (let i = 0; i < instanceData?.length; i++) {
        const item = instanceData[i];
        if (['card', undefined].includes(item?.payment_method) && instance_id !== item?._id) {
          backupInstancesIds.push({
            label: item?.name,
            value: item?._id,
          });
        }
      }
    }
    setBackupInstances(backupInstancesIds);
  }, [instanceData, instance_id]);

  const PaymentMethodTypeData = [
    {
      label: 'Card Payment',
      value: PAYMENT_METHOD_TYPES.CARD,
    },
    {
      label: 'Wallet Payment',
      value: PAYMENT_METHOD_TYPES.WALLET,
    },
    {
      label: 'BNPL Payment',
      value: PAYMENT_METHOD_TYPES.BNPL,
    },
    {
      label: 'Raast Payment',
      value: PAYMENT_METHOD_TYPES.RAAST,
      disabled: !raastMethod,
    },
    {
      label: 'Google Pay',
      value: PAYMENT_METHOD_TYPES.GOOGLE_PAY,
    },
  ];

  // Build initial values for form - same strategy as editGateway.jsx
  const values = {
    name: editData?.name ?? '',
    isDefault: editData?.isDefault || instanceData?.length === 0,
    disabled: !editData?.disabled,
    failure_instance_id: editData?.failure_instances_id || undefined,
    payment_retry_strategy: editData?.payment_retry_strategy,
    merchant: gatewayData?.merchant ?? '',
    bankUsername: gatewayData?.username ?? '',
    bankPassword: gatewayData?.password ?? '',
    webhook_secret: gatewayData?.webhook_secret ?? '',
    merchant_key: gatewayData?.merchant_key ?? '',
    merchant_secret_key: gatewayData?.merchant_secret_key ?? '',
    merchant_id: gatewayData?.merchant_id ?? '',
    merchant_password: gatewayData?.merchant_password ?? '',
    merchant_MPIN: gatewayData?.merchant_MPIN ?? '',
    integerity_salt: gatewayData?.integerity_salt ?? '',
    processing_channel_id: gatewayData?.processing_channel_id ?? '',
    access_key_id: gatewayData?.access_key_id ?? '',
    access_key_secret: gatewayData?.access_key_secret ?? '',
    scope: gatewayData?.scope ?? '',
    secret_key: gatewayData?.secret_key ?? '',
    username: gatewayData?.username ?? '',
    password: gatewayData?.password ?? '',
    store_id: gatewayData?.store_id ?? '',
    store_account_id: gatewayData?.store_account_id ?? '',
    access_code: gatewayData?.access_code,
    encryption_key: gatewayData?.encryption_key,
    merchant_domain_url: gatewayData?.merchant_domain_url,
    merchant_hash: gatewayData?.merchant_hash,
    key_one: gatewayData?.key_one,
    key_two: gatewayData?.key_two,
    merchant_username: gatewayData?.merchant_username,
    api_key: gatewayData?.api_key,
    dqr_username: gatewayData?.dqr_username ?? '',
    dqr_password: gatewayData?.dqr_password ?? '',
    dqr_hash_key: gatewayData?.dqr_hash_key ?? '',
    dqr_merchant_id: gatewayData?.dqr_merchant_id ?? '',
    dqr_terminal_id: gatewayData?.dqr_terminal_id ?? '',
    isDQRAllowed: isDQRInStore && (editData?.raast_payment_methods?.includes('dqr') ?? false),
    isRTPAllowed: isRTPInStore && (editData?.raast_payment_methods?.includes('rtp') ?? false),
    terminal: gatewayData?.terminal ?? '',
    mdd_fields: gatewayData?.mdd_fields ?? [],
  };

  const handleBankType = (e) => {
    setBankType(e.value);
  };
  const handleWalletType = (e) => {
    setWalletType(e.value);
  };
  const handleBnplType = (e) => {
    setBnplType(e.value);
  };
  const handleRaastType = (e) => {
    setRaastType(e.value);
  };
  const handleGooglePayType = (e) => {
    setGooglePayType(e.value);
  };
  const handleAuthType = (e) => {
    setAuthType(e.value);
  };
  const handlePaymentMethodType = (e) => {
    setPaymentMethodType(e.value);
  };

  const paymentRetryStrategyOptions = [
    {
      label: 'Loop',
      value: 'loop',
    },
    {
      label: 'Retain',
      value: 'retain',
    },
  ];

  const onSubmit = async (data) => {
    setLoading(true);
    let res;
    try {
      let gateway = {};
      const {
        name,
        isDefault,
        merchant,
        merchant_key,
        merchant_secret_key,
        bankUsername,
        bankPassword,
        webhook_secret,
        merchant_id,
        merchant_password,
        merchant_MPIN,
        integerity_salt,
        processing_channel_id,
        access_key_id,
        access_key_secret,
        scope,
        secret_key,
        failure_instance_id,
        payment_retry_strategy,
        username,
        password,
        store_id,
        disabled,
        store_account_id,
        access_code,
        encryption_key,
        merchant_domain_url,
        api_key,
        dqr_username,
        dqr_password,
        dqr_hash_key,
        dqr_merchant_id,
        dqr_terminal_id,
        isDQRAllowed,
        isRTPAllowed,
        terminal,
        mdd_fields,
      } = data;

      // Process failure instances
      const failure_instances_id =
        failure_instance_id?.value || failure_instance_id?.length
          ? Array.isArray(failure_instance_id) && Object.prototype.toString.call(failure_instance_id[0]) !== '[object String]'
            ? failure_instance_id?.map((data) => data?.value)
            : Array.isArray(failure_instance_id)
            ? failure_instance_id
            : [failure_instance_id?.value]
          : null;

      const sanitizedMddFields = (mdd_fields || [])
        ?.filter((field) => field?.key != null && String(field?.key)?.trim() !== '' && field?.value != null && String(field?.value)?.trim() !== '')
        ?.map((field) => ({ key: String(field?.key)?.trim(), value: String(field?.value)?.trim() }));

      // Build gateway object based on payment method type
      if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.CARD) {
        gateway = {
          payment_method: PaymentMethodTypeValue,
          merchant: merchant || gatewayData?.merchant,
          type: bankType,
          ...(bankType === Banks.PAY_FAST && { merchant_key }),
          ...(bankType === Banks.HBL || bankType === Banks.SAFE_PAY ? { merchant_key, merchant_secret_key } : { username: bankUsername, password: bankPassword, webhook_secret }),
          ...(bankType === Banks.HBL && sanitizedMddFields.length > 0 && { mdd_fields: sanitizedMddFields }),
          ...(bankType === Banks.HBL && sanitizedMddFields.length === 0 && isEditMode && gatewayData?.mdd_fields?.length > 0 && { mdd_fields: [] }),
          ...(bankType === Banks.CHECKOUT_COM && {
            authType,
            processing_channel_id,
            access_key_id,
            access_key_secret,
            scope,
            secret_key,
            webhook_secret,
          }),
          ...(bankType === Banks.SOHAR_BANK && {
            encryption_key,
            access_code,
            merchant_domain_url,
          }),
          ...(bankType === Banks.APG && {
            username,
            password,
            merchant_id,
            store_id,
            merchant_hash,
            merchant_password,
            merchant_username,
            key_one,
            key_two,
          }),
          ...(bankType === Banks.UBL && {
            username,
            password,
            store_id,
            terminal,
          }),
        };
      } else if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.WALLET && walletType === Wallets.JAZZ_CASH) {
        gateway = {
          payment_method: PaymentMethodTypeValue,
          merchant_id,
          type: Wallets.JAZZ_CASH,
          merchant_password,
          merchant_MPIN,
          integerity_salt,
        };
      } else if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.WALLET && walletType === Wallets.EASY_PAISA) {
        gateway = {
          payment_method: PaymentMethodTypeValue,
          username,
          type: Wallets.EASY_PAISA,
          password,
          store_id,
          store_account_id,
        };
      } else if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.BNPL && bnplType === Bnpl.BAADMAY) {
        gateway = {
          payment_method: PaymentMethodTypeValue,
          type: Bnpl.BAADMAY,
          api_key,
        };
      } else if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.RAAST && raastType === Banks.BAFL) {
        gateway = {
          payment_method: PaymentMethodTypeValue,
          type: Banks.BAFL,
          dqr_username,
          dqr_password,
          dqr_hash_key,
          dqr_merchant_id,
          dqr_terminal_id,
        };
      } else if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.RAAST && raastType === Banks.PAY_FAST) {
        gateway = {
          payment_method: PaymentMethodTypeValue,
          type: Banks.PAY_FAST,
          merchant: merchant || gatewayData?.merchant,
          merchant_key,
        };
      } else if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.GOOGLE_PAY && (bankType === Banks.BAFL || bankType === Banks.MCB)) {
        gateway = {
          payment_method: PaymentMethodTypeValue,
          merchant: merchant || gatewayData?.merchant,
          type: googlePayType,
          username: bankUsername,
          password: bankPassword,
          webhook_secret,
        };
      }

      // Build raast_payment_methods for RAAST gateways
      let raast_payment_methods;
      if (PaymentMethodTypeValue === PAYMENT_METHOD_TYPES.RAAST && (raastType === Banks.BAFL || raastType === Banks.PAY_FAST)) {
        const methods = [];
        if (isDQRAllowed) methods.push('dqr');
        if (isRTPAllowed) methods.push('rtp');
        if (methods?.length === 0) {
          setLoading(false);
          notification.error({ message: 'At least one payment method (DQR or RTP) must be selected.', placement: 'bottomRight' });
          return;
        }
        raast_payment_methods = methods;
      }

      const payload = {
        name,
        payment_method: PaymentMethodTypeValue,
        ...(isDefault && { isDefault }),
        ...(failure_instances_id?.length && {
          failure_instances_id,
          payment_retry_strategy: payment_retry_strategy?.value || payment_retry_strategy || 'loop',
        }),
        ...(!failure_instances_id && editData?.failure_instances_id && { failure_instances_id: null }),
        ...(!editData?.xpay_default_mids && { gateway }),
        ...(instance_id && { disabled: !disabled }),
        ...(raast_payment_methods && { raast_payment_methods }),
      };

      if (instance_id) {
        res = await http.put(`/config/instance/${instance_id}?store_id=${store._id}`, payload);
        notification.success({ message: 'Gateway Configuration Updated', description: 'Gateway configuration has been updated successfully.', placement: 'bottomRight' });
      } else {
        res = await http.post(`/config/instance/${store._id}`, payload);
        notification.success({ message: 'Gateway Added', description: 'Gateway has been added successfully.', placement: 'bottomRight' });
      }
      setLoading(false);
      updateState(res?.data?.data ?? '');
      handleOpen();
    } catch (err) {
      setLoading(false);
      notification.error({ message: err?.response?.data?.message ?? 'DATA NOT ADDED', placement: 'bottomRight' });
    }
  };

  const isDefaultInstance = Form.useWatch('isDefault', form) || editData?.isDefault;
  const currentPaymentMethod = PaymentMethodTypeValue;
  const showAcquirerFields = ((!isEditMode || (isEditMode && gatewayData)) && !editData?.xpay_default_mids) || false;

  return (
    <Form layout='vertical' initialValues={values} onFinish={onSubmit} form={form} method='post'>
      {!isEditMode && (
        <>
          <Form.Item className='customSelect modal-field mobileViewSelect' label='Payment Method Type'>
            <Select handleChange={handlePaymentMethodType} defaultValue={PaymentMethodTypeValue} optionsValue={PaymentMethodTypeData} />
          </Form.Item>
        </>
      )}
      <Form.Item
        name='name'
        label='Gateway Name'
        className='modal-field mobileInputView'
        rules={[
          {
            required: true,
            message: 'Gateway name is required',
          },
        ]}>
        <Input placeholder='Enter gateway name' name='name' />
      </Form.Item>
      {showAcquirerFields && (
        <>
          {!isEditMode && (
            <Form.Item className='customSelect mobileViewSelect modal-field' label='Acquirer'>
              {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && <Select handleChange={handleBankType} defaultValue={bankType} optionsValue={CardAcquirerBanksName} />}
              {currentPaymentMethod === PAYMENT_METHOD_TYPES.WALLET && <Select handleChange={handleWalletType} defaultValue={walletType} optionsValue={WalletsName} />}
              {currentPaymentMethod === PAYMENT_METHOD_TYPES.BNPL && <Select handleChange={handleBnplType} defaultValue={bnplType} optionsValue={BnplName} />}
              {currentPaymentMethod === PAYMENT_METHOD_TYPES.RAAST && <Select handleChange={handleRaastType} defaultValue={raastType} optionsValue={RaastBanksName} />}
              {currentPaymentMethod === PAYMENT_METHOD_TYPES.GOOGLE_PAY && <Select handleChange={handleGooglePayType} defaultValue={googlePayType} optionsValue={GooglePayBanksName} />}
            </Form.Item>
          )}
          {((currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD &&
            bankType !== Banks.CHECKOUT_COM &&
            bankType !== Banks.MBL &&
            bankType !== Banks.MEEZAN_PAYPRO &&
            bankType !== Banks.APG &&
            bankType !== Banks.SAFE_PAY) ||
            (currentPaymentMethod === PAYMENT_METHOD_TYPES.RAAST && raastType === Banks.PAY_FAST) ||
            currentPaymentMethod === PAYMENT_METHOD_TYPES.GOOGLE_PAY) && (
            <Form.Item
              name='merchant'
              label='Merchant ID'
              className='mobileInputView modal-field'
              rules={[
                {
                  required: true,
                  message: 'Merchant id is required',
                },
              ]}>
              <Input placeholder='Enter Merchant ID' name='merchant' />
            </Form.Item>
          )}
          {((currentPaymentMethod === PAYMENT_METHOD_TYPES.WALLET && walletType === Wallets.JAZZ_CASH) || (currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.APG)) && (
            <Form.Item
              name='merchant_id'
              label='Merchant ID'
              className='mobileInputView modal-field'
              rules={[
                {
                  required: true,
                  message: 'Merchant id is required',
                },
              ]}>
              <Input placeholder='Enter Merchant ID' name='merchant_id' />
            </Form.Item>
          )}
          {(currentPaymentMethod === PAYMENT_METHOD_TYPES.GOOGLE_PAY || (currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && (bankType === Banks.BAFL || bankType === Banks.MCB || bankType === Banks.MBL || bankType === Banks.MEEZAN_PAYPRO))) && (
            <>
              <Form.Item
                name='bankUsername'
                label='Username'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Username is required',
                  },
                ]}>
                <Input placeholder='Enter Username' name='bankUsername' />
              </Form.Item>
              <Form.Item
                name='bankPassword'
                label='API Password'
                className='customInputPass mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'API Password is required',
                  },
                ]}>
                <Input placeholder='Enter API Password' name='bankPassword' type='password' />
              </Form.Item>
            </>
          )}
          {(currentPaymentMethod === PAYMENT_METHOD_TYPES.GOOGLE_PAY || (currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && (bankType === Banks.BAFL || bankType === Banks.MCB))) && (
            <Form.Item
              name='webhook_secret'
              label='Webhook Secret'
              className='customInputPass mobileInputView modal-field'
              rules={[
                {
                  required: true,
                  message: 'Webhook Secret is required',
                },
              ]}>
              <Input placeholder='Enter Webhook Secret' name='webhook_secret' type='password' />
            </Form.Item>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.HBL && (
            <>
              <Form.Item
                name='merchant_key'
                label='Merchant Key'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant Key is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant Key' name='merchant_key' type='password' />
              </Form.Item>
              <Form.Item
                name='merchant_secret_key'
                label='Merchant Secret Key'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant Secret Key is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant Secret Key' name='merchant_secret_key' type='password' />
              </Form.Item>
              <div className='modal-field' style={{ marginBottom: 12 }}>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>MDD Fields (Optional)</div>
                <Form.List name='mdd_fields'>
                  {(fields, { add, remove }) => (
                    <div>
                      {fields.map((field, index) => (
                        <div key={field.key} style={{ ...mddFieldsGridStyle, marginBottom: 8 }}>
                          <Form.Item
                            name={[field.name, 'key']}
                            label='Key'
                            className='customInput mobileInputView'
                            style={{ marginBottom: 0 }}
                            validateFirst
                            rules={[
                              { required: true, message: 'Key is required' },
                              {
                                validator: (_, value) => {
                                  if (!value) return Promise.resolve();
                                  const allFields = form.getFieldValue('mdd_fields') || [];
                                  const duplicate = allFields.filter((item, idx) => item?.key === value && idx !== index);
                                  if (duplicate.length > 0) {
                                    return Promise.reject(new Error('Key must be unique'));
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}>
                            <Input placeholder='e.g. 1' />
                          </Form.Item>
                          <Form.Item
                            name={[field.name, 'value']}
                            label='Value'
                            className='customInput mobileInputView'
                            style={{ marginBottom: 0 }}
                            rules={[{ required: true, message: 'Value is required' }]}>
                            <Input placeholder='Enter value' />
                          </Form.Item>
                          <DeleteOutlined onClick={() => remove(field.name)} style={{ color: '#E12121', cursor: 'pointer', fontSize: 18, marginBottom: 10 }} />
                        </div>
                      ))}
                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                        <ANTButton type='primary' className='rounded-lg button-theme' htmlType='button' onClick={() => add({ key: undefined, value: undefined })}>
                          + Add MDD Field
                        </ANTButton>
                      </div>
                    </div>
                  )}
                </Form.List>
              </div>
            </>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.SAFE_PAY && (
            <>
              <Form.Item
                name='merchant_key'
                label='Public key'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Public key is required',
                  },
                ]}>
                <Input placeholder='Enter Public key' name='merchant_key' type='password' />
              </Form.Item>
              <Form.Item
                name='merchant_secret_key'
                label='Secret key'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Secret key is required',
                  },
                ]}>
                <Input placeholder='Enter Secret key' name='merchant_secret_key' type='password' />
              </Form.Item>
            </>
          )}
          {((currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.PAY_FAST) || (currentPaymentMethod === PAYMENT_METHOD_TYPES.RAAST && raastType === Banks.PAY_FAST)) && (
            <Form.Item
              name='merchant_key'
              label='Merchant Key'
              className='customInput mobileInputView modal-field'
              rules={[
                {
                  required: true,
                  message: 'Merchant Key is required',
                },
              ]}>
              <Input placeholder='Enter Merchant Key' name='merchant_key' type='password' />
            </Form.Item>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.WALLET && walletType === Wallets.JAZZ_CASH && (
            <>
              <Form.Item
                name='merchant_password'
                label='Merchant Password'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant Password is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant Password' name='merchant_password' type='password' />
              </Form.Item>
              <Form.Item
                name='merchant_MPIN'
                label='Merchant MPIN'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant MPIN is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant MPIN' name='merchant_MPIN' />
              </Form.Item>
              <Form.Item
                name='integerity_salt'
                label='Integerity Salt'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Integerity Salt is required',
                  },
                ]}>
                <Input placeholder='Enter Integerity Salt' name='integerity_salt' />
              </Form.Item>
            </>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.CHECKOUT_COM && (
            <>
              <Form.Item className='customSelect mobileViewSelect' label='Auth Type'>
                <Select handleChange={handleAuthType} defaultValue={authType} optionsValue={AuthName} />
              </Form.Item>
              <Form.Item
                name='processing_channel_id'
                label='Processing Channel id'
                className='modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Processing Channel id is required',
                  },
                ]}>
                <Input placeholder='Enter Processing Channel id' name='processing_channel_id' />
              </Form.Item>
              <Form.Item
                name='webhook_secret'
                label='Webhook Secret'
                className='modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Webhook Secret is required',
                  },
                ]}>
                <Input placeholder='Enter Webhook Secret' name='webhook_secret' />
              </Form.Item>
              {authType === CHECKOUT_COM_AUTH_TYPE.OAUTH && bankType === Banks.CHECKOUT_COM && (
                <>
                  <Form.Item
                    name='access_key_id'
                    label='Access Key Id'
                    className='modal-field'
                    rules={[
                      {
                        required: true,
                        message: 'Access Key Id is required',
                      },
                    ]}>
                    <Input placeholder='Enter Access Key Id' name='access_key_id' />
                  </Form.Item>
                  <Form.Item
                    name='access_key_secret'
                    label='Access Key secret'
                    className='modal-field'
                    rules={[
                      {
                        required: true,
                        message: 'Access Key secret is required',
                      },
                    ]}>
                    <Input placeholder='Enter Access Key secret' name='access_key_secret' />
                  </Form.Item>
                  <Form.Item name='scope' label='Scope' className='customInput mobileInputView'>
                    <Input placeholder='Enter Scope' name='scope' />
                  </Form.Item>
                </>
              )}
              {authType === CHECKOUT_COM_AUTH_TYPE.API && bankType === Banks.CHECKOUT_COM && (
                <>
                  <Form.Item
                    name='secret_key'
                    label='Secret key'
                    className='modal-field'
                    rules={[
                      {
                        required: true,
                        message: 'Secret key is required',
                      },
                    ]}>
                    <Input placeholder='Enter Secret key' name='secret_key' />
                  </Form.Item>
                </>
              )}
            </>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.WALLET && walletType === Wallets.EASY_PAISA && (
            <>
              <Form.Item
                name='username'
                label='Username'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Username is required',
                  },
                ]}>
                <Input placeholder='Enter Username' name='username' />
              </Form.Item>
              <Form.Item
                name='password'
                label='Password'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Password is required',
                  },
                ]}>
                <Input placeholder='Enter Password' name='password' type='password' />
              </Form.Item>
              <Form.Item
                name='store_id'
                label='Store Id'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Store Id is required',
                  },
                ]}>
                <Input placeholder='Enter Store Id' name='store_id' />
              </Form.Item>
              <Form.Item
                name='store_account_id'
                label='EWP Account Id'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'EWP Account Id is required',
                  },
                ]}>
                <Input placeholder='Enter EWP Account Id' name='store_account_id' />
              </Form.Item>
            </>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.SOHAR_BANK && (
            <>
              <Form.Item
                name='access_code'
                label='Access Code'
                className='customInputPass mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Access code is required',
                  },
                ]}>
                <Input placeholder='Enter access code' name='access_code' type='password' />
              </Form.Item>
              <Form.Item
                name='encryption_key'
                label='Working key (Encryption Key)'
                className='customInputPass mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Encryption Key is required',
                  },
                ]}>
                <Input placeholder='Enter working key (Encryption Key)' name='encryption_key' type='password' />
              </Form.Item>
              <Form.Item
                name='merchant_domain_url'
                label='Store domain Url'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Store domain Key is required',
                  },
                ]}>
                <Input placeholder='Enter store domain url' name='merchant_domain_url' />
              </Form.Item>
            </>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.APG && (
            <>
              <Form.Item
                name='username'
                label='Username'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Username is required',
                  },
                ]}>
                <Input placeholder='Enter Username' name='username' />
              </Form.Item>
              <Form.Item
                name='password'
                label='Password'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Password is required',
                  },
                ]}>
                <Input placeholder='Enter Password' name='password' type='password' />
              </Form.Item>
              <Form.Item
                name='merchant_username'
                label='Merchant Username'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant Username is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant Username' name='merchant_username' />
              </Form.Item>
              <Form.Item
                name='merchant_password'
                label='Merchant Password'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant Password is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant Password' name='merchant_password' type='password' />
              </Form.Item>
              <Form.Item
                name='store_id'
                label='Store Id'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Store Id is required',
                  },
                ]}>
                <Input placeholder='Enter Store Id' name='store_id' />
              </Form.Item>
              <Form.Item
                name='key_one'
                label='Key 1'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Key 1 is required',
                  },
                ]}>
                <Input placeholder='Enter Key 1' name='key_one' type='password' />
              </Form.Item>
              <Form.Item
                name='key_two'
                label='Key 2'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Key 2 is required',
                  },
                ]}>
                <Input placeholder='Enter Key 2' name='key_two' type='password' />
              </Form.Item>
              <Form.Item
                name='merchant_hash'
                label='Merchant Hash'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant Hash is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant Hash' name='merchant_hash' type='password' />
              </Form.Item>
            </>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.BNPL && bnplType === Bnpl.BAADMAY && (
            <>
              <Form.Item
                name='api_key'
                label='API Key'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'API Key is required',
                  },
                ]}>
                <Input placeholder='Enter API Key' name='api_key' />
              </Form.Item>
            </>
          )}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.RAAST && raastType === Banks.BAFL && (
            <>
              <Form.Item
                name='dqr_username'
                label='Username'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Username is required',
                  },
                ]}>
                <Input placeholder='Enter Username' name='dqr_username' />
              </Form.Item>
              <Form.Item
                name='dqr_password'
                label='Password'
                className='customInputPass mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Password is required',
                  },
                ]}>
                <Input placeholder='Enter Password' name='dqr_password' type='password' />
              </Form.Item>
              <Form.Item
                name='dqr_hash_key'
                label='Hash Key'
                className='customInputPass mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Hash Key is required',
                  },
                ]}>
                <Input placeholder='Enter Hash Key' name='dqr_hash_key' type='password' />
              </Form.Item>
              <Form.Item
                name='dqr_merchant_id'
                label='Merchant ID'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Merchant ID is required',
                  },
                ]}>
                <Input placeholder='Enter Merchant ID' name='dqr_merchant_id' />
              </Form.Item>
              <Form.Item
                name='dqr_terminal_id'
                label='Terminal ID'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Terminal ID is required',
                  },
                ]}>
                <Input placeholder='Enter Terminal ID' name='dqr_terminal_id' />
              </Form.Item>
            </>
          )}

          {/* UBL */}
          {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && bankType === Banks.UBL && (
            <>
              <Form.Item
                name='username'
                label='Username'
                className='mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Username is required',
                  },
                ]}>
                <Input placeholder='Enter Username' name='username' />
              </Form.Item>
              <Form.Item
                name='password'
                label='Password'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Password is required',
                  },
                ]}>
                <Input placeholder='Enter Password' name='password' type='password' />
              </Form.Item>
              <Form.Item
                name='store_id'
                label='Store ID'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Store ID is required',
                  },
                ]}>
                <Input placeholder='Enter Store ID' name='store_id' type='password' />
              </Form.Item>
              <Form.Item
                name='terminal'
                label='Terminal ID'
                className='customInput mobileInputView modal-field'
                rules={[
                  {
                    required: true,
                    message: 'Terminal ID is required',
                  },
                ]}>
                <Input placeholder='Enter Terminal ID' name='terminal' type='password' />
              </Form.Item>
            </>
          )}
        </>
      )}
      <div className='flex gap-8'>
        {!editData?.isDefault && (
          <Form.Item name='isDefault' className='modal-field' label='Default' valuePropName='checked'>
            <Switch disabled={!instanceData?.length} />
          </Form.Item>
        )}
        {isEditMode && (
          <Form.Item name='disabled' className='modal-field' label='Enable' valuePropName='checked'>
            <Switch />
          </Form.Item>
        )}
        {currentPaymentMethod === PAYMENT_METHOD_TYPES.RAAST && (
          <>
            <Form.Item name='isDQRAllowed' className='modal-field' label='DQR' valuePropName='checked'>
              <Switch disabled={!isDQRInStore} />
            </Form.Item>
            <Form.Item name='isRTPAllowed' className='modal-field' label='RTP' valuePropName='checked'>
              <Switch disabled={!isRTPInStore} />
            </Form.Item>
          </>
        )}
      </div>
      {currentPaymentMethod === PAYMENT_METHOD_TYPES.CARD && isDefaultInstance && backupInstances?.length > 0 && (
        <div className='failure-instance'>
          <Form.Item className='customSelect mobileViewSelect modal-field' name={'failure_instance_id'} label={'Gateway Instances for Payment Retry on Failure'}>
            <Select mode={backupInstances?.length > 1 ? 'multiple' : 'none'} placeholder={'Select failure gateway id'} allowClear={true} showSearch={true} optionsValue={backupInstances} />
          </Form.Item>
          <Form.Item className='w-full' label='Payment Retry Strategy' name={'payment_retry_strategy'}>
            <Select optionsValue={paymentRetryStrategyOptions} />
          </Form.Item>
        </div>
      )}
      <Form.Item className='mobileInputView'>
        <div className='flex'>
          <ANTButton block className='rounded-lg' onClick={() => handleOpen()}>
            Cancel
          </ANTButton>
          <Button block type='primary' className='primaryBtn ml-4' htmlType='submit' loading={loading}>
            {isEditMode ? 'Update' : 'Submit'}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};

export default GatewayInstance;
